const pageTrackingEventMap = {
    "shipping-address": 'checkout_step_1',
    "shipping-options": 'checkout_step_2',
    "packaging-options": 'checkout_step_3',
    "payment-options": 'checkout_step_4',
    review: 'checkout_step_5',
}

export const trackPage = (optimizely, value, isPath = false) => {
    const page = isPath ? value.split('/').pop() : value
    const eventKey = pageTrackingEventMap[page] || page

    optimizely.onReady?.().then(() => {
        eventKey && optimizely.track?.(eventKey)
        eventKey && window?.OptimizelyWebInterface?.trackEvent?.(eventKey)
    }).catch(() => { })
};

export const trackOrder = (optimizely, { orderId, lineItems, genericTotal, transactionTotal } = {}) => {
    if (orderId && lineItems && genericTotal) {
        const { amount = 0, divisor = 0 } = getAnalyticsPrice(genericTotal, 'GrandTotal_Daily_EUR', { amount: transactionTotal * 100, divisor: 100 })
        const totalQuantity = lineItems.reduce((acc, item) => acc + item.quantity, 0)
        const eventKey = 'order'
        const eventTags = {
            orderId,
            totalRevenueEuros: amount / divisor,
            value: totalQuantity,
            revenue: amount
        }

        optimizely.onReady?.().then(() => {
            optimizely.track?.(eventKey, eventTags)

            // Tracking optimizley event in TON iOS
            window?.OptimizelyWebInterface?.trackEvent?.(eventKey, eventTags)

            lineItems.forEach(item => {
                trackItem(optimizely, orderId, item)
            })
        }).catch(() => { })
    }
};

const trackItem = (optimizely, orderId, { quantity, genericTotal }) => {
    const { amount, divisor } = getAnalyticsPrice(genericTotal, 'adjustedOrderItemPrice_Daily_EUR', 'adjustedOrderItemPrice')
    const eventKey = 'unit_purchased'
    const eventTags = {
        orderId,
        unitQty: quantity,
        unitTotalRevenueEuros: amount / divisor,
        revenue: amount
    }

    optimizely.track?.(eventKey, eventTags)

    // Tracking optimizley event in TON iOS
    window?.OptimizelyWebInterface?.trackEvent?.(eventKey, eventTags)
}

export const getAnalyticsPrice = (genericTotal, key, fallback) => {
    const grandTotalEUR = genericTotal?.find(({ name }) => name === key)?.value
    const fallbackTotal = typeof fallback === 'string' ? genericTotal?.find(({ name }) => name === fallback)?.value : fallback
    return grandTotalEUR || fallbackTotal

}

export const trackOrderShoes = (optimizely, { lineItems = [] } = {}) => {
    const eventKey = 'shoesorder'
    const totalQuantity = lineItems?.reduce((acc, item) => item?.category?.primaryCategory?.toLowerCase() === 'shoes' ? ++acc : acc, 0)

    const eventTags = {
        totalQuantity,
    }

    if (totalQuantity > 0) {
        optimizely.onReady?.().then(() => {
            optimizely.track?.(eventKey, eventTags)
        })
    }
}